export const QueryPanelActionTypes = {
  LOAD_ALL_SG_INFO_START: '[queryPanel] LOAD_ALL_SG_INFO_START',
  LOAD_ALL_SG_INFO_SUCCESS: '[queryPanel] LOAD_ALL_SG_INFO_SUCCESS',
  LOAD_ALL_SG_INFO_FAILURE: '[queryPanel] LOAD_ALL_SG_INFO_FAILURE',

  LOAD_SG_INFO_START: '[queryPanel] LOAD_SG_INFO_START',
  LOAD_SG_INFO_SUCCESS: '[queryPanel] LOAD_SG_INFO_SUCCESS',
  LOAD_SG_INFO_FAILURE: '[queryPanel] LOAD_SG_INFO_FAILURE',
  RESET_SG_INFO: '[queryPanel] RESET_SG_INFO',


  LOAD_ITEM_COUNT_START: '[queryPanel] LOAD_ITEM_COUNT_START',
  LOAD_ITEM_COUNT_SUCCESS: '[queryPanel] LOAD_ITEM_COUNT_SUCCESS',
  LOAD_ITEM_COUNT_FAILURE: '[queryPanel] LOAD_ITEM_COUNT_FAILURE',
  RESET_ITEM_COUNT: '[queryPanel] RESET_ITEM_COUNT'
};
